const API_PREFIXES = [
  '/dev-api/contest/open',
  '/prod-api/contest/open'
]

function parseJsonSafely (text, url, status) {
  try {
    return JSON.parse(text)
  } catch (error) {
    const preview = String(text || '').trim().slice(0, 120)
    throw new Error(`竞赛活动接口返回非 JSON: ${url} (status: ${status}, body: ${preview || 'empty'})`)
  }
}

async function requestJson (path) {
  let lastError = null

  for (const prefix of API_PREFIXES) {
    const url = `${prefix}${path}`
    try {
      const response = await fetch(url)
      const responseText = await response.text()
      const result = parseJsonSafely(responseText, url, response.status)
      if (!response.ok) {
        throw new Error(result.msg || `请求失败: ${url} (status: ${response.status})`)
      }
      if (result.code !== 200) {
        throw new Error(result.msg || `请求失败: ${url}`)
      }
      return result.data
    } catch (error) {
      lastError = error
    }
  }

  throw lastError || new Error(`请求失败: ${path}`)
}

export function fetchContestCurrentActivity () {
  return requestJson('/activity/current')
}



// WEBPACK FOOTER //
// ./src/utils/contest.js